//auth Action Types
// register
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTRATION_STARTED = "REGISTRATION_STARTED";
export const REGISTER_FAIL = "REGISTER_FAIL";
// login
export const LOGIN_STARTED = "LOGIN_STARTED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";

//logout
export const LOGOUT = "LOGOUT";

//Profile
export const FETCH_PROFILE_STARTED = "FETCH_PROFILE_STARTED";
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAIL = "FETCH_PROFILE_FAIL";

//update profile
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const DELETE_PROFILE_FAIL = "DELETE_PROFILE_FAIL";
